<template>
  <div class="F404PageBox">
    <div class="font">404</div>
    <div class="title">{{ title }}Page开发中~~~~敬请期待！</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      title: String
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.F404PageBox {
  width: 930px;
  height: 980px;
  // background-color: #000;
  // background: url("../../assets/404/404.jpg") no-repeat 0px 0px;
  // background-size: 100%;
  .font {
    color: #fff;
    font-size: 300px;
    padding: 200px;
    text-shadow: 15px 15px 15px rgb(0 38 109);
  }
  .title{
    color: rgb(219, 2, 248);
    font-size: 20px;
    margin-left: 550px;
    margin-top: -200px;
  }
}
</style>